import { observable, action, makeObservable } from 'mobx';
import { InputType } from './types';

export class TextListInput implements InputType {
  dataType: string;

  label: string;

  placeholder?: string;

  tag: string;

  @observable selectorValue!: string | null;

  @observable value!: string[];

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: InputType) {
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null); // set initial value
    this.onChangeValue([]); // set initial value
  }

  // onChange do not change the value, only the selecion
  @action
  onChange = (v: string | null) => {
    this.selectorValue = v;
  };

  // onChangeValue changes the array
  @action
  onChangeValue = (v: string[]) => {
    this.value = v;
    this.selectorValue = null;
  };

  @action
  clearValue = () => {
    this.selectorValue = null;
    this.value = [];
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
